var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAttach(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.67312 2C4.68459 2 3.19033 2 2.26191 2.92806C1.3335 3.85612 1.3335 5.3498 1.3335 8.33717C1.3335 11.3245 1.3335 12.8182 2.26191 13.7463C3.19033 14.6744 4.68459 14.6743 7.67312 14.6743C10.6616 14.6743 12.1559 14.6744 13.0843 13.7463C14.0127 12.8182 14.0127 11.3245 14.0127 8.33717V8.00364",
    stroke: "#3D3D43",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.3335 14.0003C6.14015 10.8328 9.2943 6.63197 14.0002 9.78257",
    stroke: "#3D3D43"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9985 1.33887V6.67762M14.6689 3.99153L9.32812 4.00145",
    stroke: "#3D3D43",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAttach);
export default __webpack_public_path__ + "static/media/icon-attach.cfa09ac829f85856a02f82d3c50e73fa.svg";
export { ForwardRef as ReactComponent };